import { Paper } from '@material-ui/core';
import { format } from 'date-fns';
import React, { useState } from 'react';

import Tooltip from 'src/components/general/Tooltip';
import type { ScheduleLogQueue } from 'src/dropInClinic/hooks/useScheduleLogs';

const ScheduleQueue = ({ queue }: { queue: ScheduleLogQueue[] }) => {
  const [showAll, setShowAll] = useState(false);
  const initialItems = 3;
  const displayedItems = showAll ? queue : queue.slice(0, initialItems);

  return (
    <div>
      {displayedItems.map((request: ScheduleLogQueue) => {
        const toolTip = (
          <>
            Patient: {request.patient.firstName} {request.patient.lastName} <br />
            Request ID: {request.requestId} <br />
            Request Type: {request.requestType} <br />
            Queued At: {format(new Date(request.queuedAt), 'p')} <br />
            Bonuses: {JSON.stringify(request.bonuses, null, 2)} <br />
          </>
        );
        return (
          <Tooltip key={request.requestId} title={toolTip}>
            <Paper
              elevation={2}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 8,
              }}
            >
              <div style={{ padding: 4, justifyContent: 'center' }}>{request.patient.id}</div>
            </Paper>
          </Tooltip>
        );
      })}
      {queue.length > initialItems && (
        <div
          onClick={() => setShowAll(!showAll)}
          style={{
            color: '#1976d2',
            cursor: 'pointer',
            fontSize: '0.875rem',
            textAlign: 'right',
          }}
        >
          {showAll ? 'Show less' : `Show ${queue.length - initialItems} more`}
        </div>
      )}
    </div>
  );
};

export default ScheduleQueue;
